/*
 * Back-to-top button
 *   - Click on any .js-back-to-top → smooth-scroll to top.
 *   - Currently used only by the footer's permanent button; the previous
 *     floating-right-edge variant has been removed.
 */

export function initBackToTop() {
    const buttons = Array.from(document.querySelectorAll('.js-back-to-top'));
    if (!buttons.length) return;

    buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
}
